import { render, staticRenderFns } from "./AllocationCustom.vue?vue&type=template&id=8d146262&scoped=true"
import script from "./AllocationCustom.vue?vue&type=script&lang=js"
export * from "./AllocationCustom.vue?vue&type=script&lang=js"
import style0 from "./AllocationCustom.vue?vue&type=style&index=0&id=8d146262&prod&lang=css"
import style1 from "./AllocationCustom.vue?vue&type=style&index=1&id=8d146262&prod&lang=scss"
import style2 from "./AllocationCustom.vue?vue&type=style&index=2&id=8d146262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d146262",
  null
  
)

export default component.exports